module.exports = __webpack_public_path__ + "img/total.ca4ac604.jpg";